import { render, staticRenderFns } from "./DeviceCommandCardContent.vue?vue&type=template&id=2bfa8677"
import script from "./DeviceCommandCardContent.vue?vue&type=script&lang=js"
export * from "./DeviceCommandCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports